/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionIssuersGet } from "../funcs/organizationRemoteSessionIssuersGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteSessionIssuer } from "../models/components/remotesessionissuer.js";
import {
  GetOrganizationRemoteSessionIssuerRequest,
  GetOrganizationRemoteSessionIssuerSecurity,
} from "../models/operations/getorganizationremotesessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationRemoteSessionIssuerQueryData = RemoteSessionIssuer;

export function prefetchOrganizationRemoteSessionIssuer(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetOrganizationRemoteSessionIssuerRequest,
  security?: GetOrganizationRemoteSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionIssuerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationRemoteSessionIssuerQuery(
  client$: GramCore,
  request: GetOrganizationRemoteSessionIssuerRequest,
  security?: GetOrganizationRemoteSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionIssuerQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionIssuer({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function organizationRemoteSessionIssuerQueryFn(
      ctx,
    ): Promise<OrganizationRemoteSessionIssuerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationRemoteSessionIssuersGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOrganizationRemoteSessionIssuer(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionIssuers",
    "get",
    parameters,
  ];
}
